var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"st-content-footer"},[_c('p',{directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.footer),expression:"footer"}],staticClass:"st-footer"})])}
var staticRenderFns = []

export { render, staticRenderFns }